import React, { useEffect, useState } from 'react';
import { useTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import PersonIcon from '@material-ui/icons/Person';
import { Button } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Cookies from 'js-cookie';

import Users from './Users';
import Groups from './Groups';
import UserDetails from './UserDetails';
import DisableUser from './DisableUser';
import ResendInvitation from './Notification/ResendInvitation';
import '../../scss/components/_user_management.scss';

import API_PATH from "../../constants/config.json";
import AddUser from './AddUser';
import GroupTabs from './GroupTabs';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;


function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography component="div">{children}</Typography>
          </Box>
        )}
      </div>
    );
}
  
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
  
function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const UserManagement = props => {

    const theme = useTheme();
    const [value, setValue] = useState(0);
    const [usTab, setUsTab] = React.useState("fo");
    const [teTab, setTeTab] = React.useState("fo");

    const [showUserDetails, setShowUserDetails] = useState(false);
    const [showDisableUser, setShowDisableUser] = useState(false);
    const [activeUsername, setActiveUsername] = useState(null);
    const [showAddUser, setShowAddUser] = useState(false);
    const [needToReload, setNeedToReload] = useState(false);

    const [showGroupTabs, setShowGroupTabs] = useState(false);
    const [selectedUserID, setSelectedUserID] = useState(null);
    const [selectedUserStatus, setSelectedUserStatus] = useState(null);
    const [showActions, setShowActions] = useState(false);
    const [actionsTop, setActionsTop] = useState(0);
    const [actionsLeft, setActionsLeft] = useState(0);
    const [scrolled, setScrolled] = useState(false);
    const [userInvited, setUserInvited] = useState(false);
    const [userEmail, setUserEmail] = useState(false);
    const [showInvitationStatus, setShowInvitationStatus] = useState(false);
    const [invitationStatus, setInvitationStatus] = useState('');
    const [invitationDescription, setInvitationDescription] = useState('');
    const [invitationTextButton, setInvitationTextButton] = useState('');


    useEffect(() => {
        if(!needToReload) {
            setNeedToReload(true);
        }
    }, [])

    useEffect(()=>{
    },[showInvitationStatus]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setNeedToReload(true);
        setScrolled(false);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const handleUserDetails = (user_id, section) => {
        sessionStorage.setItem('viewUserId', user_id);
        setShowUserDetails(true);
    }

    const handleShowDisableUser = (opt) => {
        setShowDisableUser(opt);
    }

    const handleDisableUser = () => {
        setNeedToReload(false);
        try {
            axios({
              method: 'post',
              data: {
                "userId": parseInt(sessionStorage.getItem('viewUserId')),
              },
              headers: {
                'payload': Cookies.get('payload'),
                'agencyid': sessionStorage.getItem('agency_id')
              },
              url: API_URL + API_PATH.disableuser,
            })
              .then(async function (response) {
                setShowDisableUser(false);
                setNeedToReload(true);
              })
              .catch(function (error) {
                console.error(error);
              })
        } catch (error) {
            console.error(error);
        }
    }

    const handleGroupTabs = (teamId) => {
        sessionStorage.setItem('teamId', teamId);
        setShowGroupTabs(true);
    }

    const handleShowActions = (e,user_id,fname, lname, status, user_status, email) => {
        sessionStorage.setItem('viewUserId', user_id);
        setActiveUsername(fname+" "+lname);
        setSelectedUserID(user_id);
        setSelectedUserStatus(status);
        setActionsTop(e.pageY);
        setActionsLeft(e.pageX-110);
        setUserInvited(user_status);
        setUserEmail(email);
        setShowActions(true);
    }

    const handleClickAway = () => {
        setShowActions(false);
    }

    const resendInvitation = () => {
        setNeedToReload(false);
        try {
            axios({
              method: 'post',
              data: {
                "email": userEmail,
              },
              headers: {
                'payload': Cookies.get('payload'),
              },
              url: API_URL + API_PATH.resendInvitation,
            })
              .then(async function (response) {
                if (response.data.status === "success"){
                    setInvitationStatus('Success!');
                    setInvitationDescription('Invitation email successfully resent to');           
                    setInvitationTextButton('Continue');
                    setNeedToReload(true);
                }
                else{
                    setInvitationStatus('An error occurred');
                    setInvitationDescription('An error occurred while attempting to resend the invitation. Please try again.');
                    setInvitationTextButton('Dismiss');
                }
                setShowInvitationStatus(true);
              })
              .catch(function (error) {
                setInvitationStatus('An error occurred');
                setInvitationDescription('An error occurred while attempting to resend the invitation. Please try again.');
                setInvitationTextButton('Dismiss');
                setShowInvitationStatus(true);
                console.error(error);
              })
        } catch (error) {
            console.error(error);
        }
    }

    const handleUserAction = (opt) => {
        setShowActions(false);
        if(opt === 'details') 
            handleUserDetails(selectedUserID, selectedUserStatus);
        else if (opt === 'disable')
            handleShowDisableUser(true);
        else{
            resendInvitation();
        }
    }

    const handleScroll = (tableRef) => {
        if (tableRef.current) {
          const { scrollTop } = tableRef.current.children[0].children[1].children[0].children[0].children[0].children[0].children[1];
          if (scrollTop > 0) {
            setScrolled(true);
          } else {
            setScrolled(false);
          }
        }
    };

    return (
        <React.Fragment>
            <CssBaseline />
            <div className="management-main">
                <Container className="management-container" maxWidth="lg">
                    <AppBar position="static" color="default" className="tabs-header">
                        <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        aria-label="full width tabs example"
                        >
                            <Tab label="Users" {...a11yProps(0)} id="userTabb" data-testid="userListTab" className={usTab} />
                            <Tab label="Groups" {...a11yProps(1)} id="team_tab" data-testid="teamListTab" className={teTab} />
                        </Tabs>
                        <div className="add-user-cnt">
                            <button className="add-user-btn" onClick={() => setShowAddUser(true) }><img src={require('../../assets/icons/person.svg')} /> Add user</button>
                            <img src={require('../../assets/icons/close.svg')} onClick={() => props.setOpenUserManagement(false)} />
                        </div>
                    </AppBar>
                    <SwipeableViews
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={value}
                        onChangeIndex={handleChangeIndex}
                    >
                        <TabPanel value={value} index={0} dir={theme.direction} >
                        <div className="users-table-cnt" >                           
                            <Users 
                                handleUserDetails={handleUserDetails} 
                                setShowUserDetails={setShowUserDetails}  
                                setActiveUsername={setActiveUsername}
                                handleShowDisableUser={handleShowDisableUser}
                                setShowAddUser={setShowAddUser}
                                needToReload={needToReload}
                                handleShowActions={handleShowActions}
                                handleScroll={handleScroll}
                                scrolled={scrolled}
                            />
                        </div>
                        </TabPanel>
                        <TabPanel value={value} index={1} dir={theme.direction} >
                        <div className="users-table-cnt" >
                            <Groups 
                                handleGroupTabs={handleGroupTabs}
                                setShowGroupTabs={setShowGroupTabs}
                                needToReload={needToReload}
                                handleScroll={handleScroll}
                                scrolled={scrolled}
                            />
                        </div>
                        </TabPanel>
                    </SwipeableViews>
                </Container>
            </div>
            {/* User details modal */}
            {
                showUserDetails &&
                <UserDetails 
                    setShowUserDetails={setShowUserDetails} 
                    handleShowDisableUser={handleShowDisableUser} 
                    setActiveUsername={setActiveUsername}
                    setNeedToReload={setNeedToReload}
                    needToReload={needToReload}
                />
            }
            {/* Disable user modal */}
            {
                showDisableUser &&
                <DisableUser 
                    username={activeUsername} 
                    handleShowDisableUser={handleShowDisableUser} 
                    handleDisableUser={handleDisableUser} 
                    setNeedToReload={setNeedToReload}
                />
            }
            {/* Add user modal */}
            {
                showAddUser &&
                <AddUser 
                    setShowAddUser={setShowAddUser}
                    setNeedToReload={setNeedToReload}
                />
            }
            {
                showGroupTabs &&
                <GroupTabs 
                    setShowGroupTabs={setShowGroupTabs}
                    handleUserDetails={handleUserDetails}
                    setActiveUsername={setActiveUsername}
                    handleShowDisableUser={handleShowDisableUser}
                    needToReload={needToReload}
                    setNeedToReload={setNeedToReload}
                    handleShowActions={handleShowActions}
                    handleScroll={handleScroll}
                    scrolled={scrolled}
                />
            }
            {
                showInvitationStatus && 
                <ResendInvitation 
                setShowInvitationStatus={setShowInvitationStatus}
                invitationStatus={invitationStatus}
                invitationDescription={invitationDescription}
                activeUsername={activeUsername}
                invitationTextButton={invitationTextButton}
                />
            }
            {
                showActions &&
                <ClickAwayListener onClickAway={handleClickAway}>
                <div className="actions-panel-user-management" style={{top: actionsTop+'px', left: actionsLeft+'px'}}>
                        <div onClick={() => handleUserAction('details')}>
                            <img src={require('../../assets/icons/user-details.svg')} />
                            <label>View details</label>
                        </div>
                        <div onClick={() => handleUserAction('disable')}>
                            <img src={require('../../assets/icons/disable-user.svg')} />
                            <label>Disable</label>
                        </div>
                        {
                        userInvited &&
                            <div onClick={() => handleUserAction('resend')} style={{borderTop:"1px solid #D4D4D8"}}>
                                <img src={require('../../assets/icons/mail.svg')} />
                                <label>Re-send Invit.</label>
                            </div>
                        }
                    </div>
                </ClickAwayListener>
            }
        </React.Fragment>
    )
}

export default UserManagement;